import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
import { InventoryResourceRequirement } from "../../generic/inventory-resource-requirement/InventoryResourceRequirement";
export var RequirementItemExpansions = function (_a) {
    var resourceInfo = _a.resourceInfo;
    var resource = resourceInfo.resource, cost = resourceInfo.cost;
    return (React.createElement(InventoryResourceRequirement, { required: cost, resourceId: resource.id, iconStyleId: IdStyles.IconMedium }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/expansions/RequirementItemExpansions.tsx
// module id = 2869
// module chunks = 3